<template>
  <header>
    <nav class="navbar">
      <div class="navbar-item">
        <BasicButton
          v-if="showBackButton"
          variant="link"
          @buttonClicked="stepBack"
          additional-button-classes="color-text-color navbar-back"
          >Zurück</BasicButton
        >
      </div>
      <div class="navbar-brand navbar-item">
        <img :src="logoPath" :alt="logoAlt" />
      </div>
      <div class="progressbar-wrapper navbar-item">
        <ProgressBar v-if="!isInternalView" :steps="5" />
      </div>
    </nav>
  </header>
</template>

<script lang="ts">
  import { computed, defineComponent } from 'vue';
  import ProgressBar from '@/components/ProgressBar.vue';
  import NavService from '@/services/nav-service';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';
  import BasicButton from '@/components/Buttons/BasicButton.vue';

  export default defineComponent({
    name: 'TheHeader',
    components: {
      ProgressBar,
      BasicButton,
    },
    setup() {
      const store = useStore();
      const route = useRoute();
      const content = computed(() => store.getters.content);

      const logoPath = computed(() => {
        const fileName = store.getters.isPrintSubscription
          ? 'logoPrint.png'
          : 'logo.svg';
        return `/${store.state.tenant}/${fileName}`;
      });

      const logoAlt = computed(() => {
        return store.getters.isPrintSubscription
          ? content.value.header.logoPrintAlt
          : content.value.header.logoAlt;
      });

      const isInternalView = computed(() => {
        return route.path.includes('/internal');
      });

      const stepBack = function () {
        NavService.handleStepBack();
      };

      const showBackButton = computed(() => {
        const routesWithoutBackButton = [
          'Start',
          'SuccessPage',
          'ErrorPage',
          'RegistrationSuccess',
          'GpLocked',
          'FollowUpOffer',
          'OrderExists',
        ];

        const currentRouteName = NavService.getCurrentRouteName();
        const backButtonShouldBeDisabled =
          currentRouteName &&
          routesWithoutBackButton.includes(currentRouteName);

        return !backButtonShouldBeDisabled;
      });

      return {
        content,
        logoPath,
        isInternalView,
        stepBack,
        showBackButton,
        logoAlt,
      };
    },
  });
</script>
